import React from 'react';
import { string } from 'prop-types';
import styles from './Chevron.module.sass';

const rotationForDirection = direction => {
  switch (direction) {
    case 'up':
      return -270;

    case 'left':
      return -180;

    case 'down':
      return 90;

    default:
      return 0;
  }
};

const arrow = angle => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 40 40"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.4538852,34 C14.0827813,34 13.7101881,33.842282 13.4258692,33.5242779 C12.8580436,32.8906868 12.8580436,31.8653689 13.4258692,31.2317778 L23.4923843,20.0001133 L13.4258692,8.7676935 C12.8580436,8.13410236 12.8580436,7.10787808 13.4258692,6.47519336 C13.9936947,5.84160221 14.9133988,5.84160221 15.4810889,6.47519336 L26.5741308,18.8530323 C27.1419564,19.4866235 27.1419564,20.5128478 26.5741308,21.1455325 L15.4810889,33.5241268 C15.1977177,33.8413756 14.8258015,34 14.4538852,34 Z",
  transform: `translate(20.000000, 20.000000) rotate(${angle}) translate(-20.000000, -20.000000)`
}));

const Chevron = props => /*#__PURE__*/React.createElement("span", {
  className: `${styles['chevron']} ${props.className || ''} ${styles[props.direction || 'right'] || ''}`
}, arrow(rotationForDirection(props.direction)));

Chevron.displayName = 'Chevron';
Chevron.propTypes = {
  className: string,
  direction: string
};
export default Chevron;